import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=e6948da8&xmlns%3Av-img=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=e6948da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports